// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest, putRequest, postBodyRequest, getNoAuthRequest, postNoAuthRequest } from '@/libs/axios';

// 分页获取数据
export const getAccesslogList = (params) => {
    return postRequest('/busi/accesslog/getByCondition', params)
}
// 添加
export const addAccesslog = (params) => {
    return postRequest('/busi/accesslog/insert', params)
}
// 编辑
export const editAccesslog = (params) => {
    return postRequest('/busi/accesslog/update', params)
}
// 删除
export const deleteAccesslog = (params) => {
    return postRequest('/busi/accesslog/delByIds', params)
}